import axios from "./api";
import {toast} from "react-toastify";

const PutyovkaService = {

    async getPutyovkaList(pageNumber, perPage, search, orderBy, days, transportId, last) {
        try {
            const response = await axios.get('/putyofka', {
                params: {
                    per_page: perPage,
                    page: pageNumber,
                    search: search,
                    order_by: orderBy,
                    days: days,
                    transport_id: transportId,
                    last: last
                }
            });
            return response.data;
        } catch (error) {
            toast.error('Putyovka listini yuklashda xatolik, saytni yangilab yuboring');
        }
    },

    /**
     * response data should look like this
     * {
     *   "success": true,
     *   "message": "Transport ma'lumotlari muvaffaqiyatli olindi",
     *   "data": {
     *     "id": 3,
     *     "transport_id": 1,
     *     "raqam": "PT-004",
     *     "dan": "2025-06-29",
     *     "gacha": "2025-06-30",
     *     "narx": 19990,
     *     "created_at": "2025-07-02T11:06:45.000000Z",
     *     "updated_at": "2025-07-02T13:46:56.000000Z",
     *     "transport": {
     *       "id": 1,
     *       "tur_id": 2,
     *       "ega_id": 1,
     *       "name": "Isuzu NQR",
     *       "davlat_raqam": "01A123BC",
     *       "tex_passport_raqam": "AC1234567",
     *       "rang": "Oq",
     *       "izoh": "Yangi keltirilgan transport (ixtiyoriy)",
     *       "created_at": "2025-07-02T09:58:45.000000Z",
     *       "updated_at": "2025-07-02T09:58:45.000000Z",
     *       "ega": {
     *         "id": 1,
     *         "name": "Alisher",
     *         "username": "admin",
     *         "phone": "998911157709",
     *         "email": "admin@gmail.com",
     *         "email_verified_at": "2022-01-02T12:04:58.000000Z",
     *         "dob": "2000-10-10",
     *         "prava_raqam": null,
     *         "google_id": null,
     *         "facebook_id": null,
     *         "github_id": null,
     *         "avatar": "1751464722.jpg",
     *         "created_at": "2025-07-02T09:57:55.000000Z",
     *         "updated_at": "2025-07-02T13:58:42.000000Z"
     *       }
     *     },
     *     "shafyors": [
     *       {
     *         "id": 10,
     *         "putyofka_id": 3,
     *         "user_id": 2,
     *         "created_at": "2025-07-03T07:31:18.000000Z",
     *         "updated_at": "2025-07-03T07:31:18.000000Z",
     *         "shafyor": {
     *           "id": 2,
     *           "name": "Sanjarbek",
     *           "username": null,
     *           "phone": "2",
     *           "email": null,
     *           "email_verified_at": null,
     *           "dob": null,
     *           "prava_raqam": "AD62623262",
     *           "google_id": null,
     *           "facebook_id": null,
     *           "github_id": null,
     *           "avatar": null,
     *           "created_at": "2025-07-02T10:43:58.000000Z",
     *           "updated_at": "2025-07-02T10:43:58.000000Z"
     *         }
     *       }
     *     ],
     *     "putyofka_priseps": [
     *       {
     *         "id": 2,
     *         "putyofka_id": 3,
     *         "transport_id": 5,
     *         "created_at": "2025-07-03T07:31:18.000000Z",
     *         "updated_at": "2025-07-03T07:31:18.000000Z",
     *         "transport": {
     *           "id": 5,
     *           "tur_id": 1,
     *           "ega_id": 1,
     *           "name": "Prisep 1",
     *           "davlat_raqam": "01A123BC1GA",
     *           "tex_passport_raqam": "TX12345678",
     *           "rang": null,
     *           "izoh": null,
     *           "created_at": "2025-07-03T07:29:22.000000Z",
     *           "updated_at": "2025-07-03T07:29:22.000000Z",
     *           "ega": {
     *             "id": 1,
     *             "name": "Alisher",
     *             "username": "admin",
     *             "phone": "998911157709",
     *             "email": "admin@gmail.com",
     *             "email_verified_at": "2022-01-02T12:04:58.000000Z",
     *             "dob": "2000-10-10",
     *             "prava_raqam": null,
     *             "google_id": null,
     *             "facebook_id": null,
     *             "github_id": null,
     *             "avatar": "1751464722.jpg",
     *             "created_at": "2025-07-02T09:57:55.000000Z",
     *             "updated_at": "2025-07-02T13:58:42.000000Z"
     *           }
     *         }
     *       },
     *       {
     *         "id": 3,
     *         "putyofka_id": 3,
     *         "transport_id": 6,
     *         "created_at": "2025-07-03T07:31:18.000000Z",
     *         "updated_at": "2025-07-03T07:31:18.000000Z",
     *         "transport": {
     *           "id": 6,
     *           "tur_id": 1,
     *           "ega_id": 1,
     *           "name": "Prisep 2",
     *           "davlat_raqam": "01A123BCCCV",
     *           "tex_passport_raqam": "TX12345678910",
     *           "rang": null,
     *           "izoh": null,
     *           "created_at": "2025-07-03T07:30:52.000000Z",
     *           "updated_at": "2025-07-03T07:30:52.000000Z",
     *           "ega": {
     *             "id": 1,
     *             "name": "Alisher",
     *             "username": "admin",
     *             "phone": "998911157709",
     *             "email": "admin@gmail.com",
     *             "email_verified_at": "2022-01-02T12:04:58.000000Z",
     *             "dob": "2000-10-10",
     *             "prava_raqam": null,
     *             "google_id": null,
     *             "facebook_id": null,
     *             "github_id": null,
     *             "avatar": "1751464722.jpg",
     *             "created_at": "2025-07-02T09:57:55.000000Z",
     *             "updated_at": "2025-07-02T13:58:42.000000Z"
     *           }
     *         }
     *       }
     *     ],
     *     "putyofka_yonalishs": [
     *       {
     *         "id": 10,
     *         "putyofka_id": 3,
     *         "from_davlat": "Uzb",
     *         "to_davlat": "Kzg",
     *         "created_at": "2025-07-03T07:31:18.000000Z",
     *         "updated_at": "2025-07-03T07:31:18.000000Z"
     *       }
     *     ]
     *   }
     * }
     * @param putyovkaId
     * @returns {Promise<any>}
     */
    async getPutyovkaById(putyovkaId) {
        try {
            const response = await axios.get('/putyofka/' + putyovkaId);
            return response.data;
        } catch (error) {
            toast.error('Putyovka topishda xatolik');
        }
    },
    async updatePutyovka(formData, id) {
        try {
            console.log('updatega keldi', formData)
            const response = await axios.put('/putyofka/' + id, formData);
            console.log(response.data);
            return response.data;
        } catch (error) {
            toast.error('Putyovka o‘zgartirishda xatolik, putyovka raqami mavjud bolishi mumkin');
            // throw error.response?.data?.message || 'Error updating Putyovka';
        }
    },
    async deletePutyovka(id) {
        try {
            const response = await axios.delete('/putyofka/' + id);
            return response.data;
        } catch (error) {
            // throw error.response?.data?.message || 'Error deleting litsenziya';
            toast.error('Putyovka o‘chirishda xatolik, boglangan boshqa fayllar mavjud');
        }
    },
    async addPutyovka(obj) {
        try {
            console.log('keldi', obj)
            const response = // Nestlangan objectlarni JSON string qilib yuboring:
                await axios.post('/putyofka', {
                    transport_id: obj.transport_id,
                    raqam: obj.raqam,
                    narx: obj.narx,
                    dan: obj.dan,
                    gacha: obj.gacha,
                    shafyors: obj.shafyors,
                    putyofka_priseps: obj.putyofka_priseps,
                    putyofka_yonalishs: obj.putyofka_yonalishs
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });


            console.log('response', response)
            return response.data;
        } catch (error) {
            toast.error("Putyovka yaratishda xatolik, Ehtimol bu raqamdagi putyovka mavjud");
            // throw error.response?.data?.message || 'Error creating putyovka';
        }
    },

    async generatePDF(putyovkaId, global) {
        try {
            const response = await axios.get('/pdf_generator/putyofka/' + putyovkaId, {
                responseType: 'blob',
                params: {
                    global: global
                },
            });
            return response;
        } catch (error) {
            toast.error("Fayl yuklashda xatolik");
            return null; // <-- QAYTARISH SHART
            // throw error.response?.data?.message || 'Error creating putyovka';
        }
    },

    async getLastIndex(){
        try {
            const response = await axios.get('/last_putyofka');
            return response.data;
        }catch (error) {
            console.log(error)
        }
    }
}

export default PutyovkaService
;